<template>
  <k-editor-form v-if="list_type && contents">
    <template #left>
      <k-text-field textarea label="Import data" ref="data" v-model="import_data"></k-text-field>
      <k-btn @click.stop="create_data()">Convert</k-btn>

      <div>
        <template v-if="converted">
          <editor :data="id" ref="editor" :initial="converted" :noheight="true" :hideactions="true"></editor>
        </template>
      </div>

    </template>

    <template #right-buttons>
      <k-btn size="m" color="success" @click="save(true)">Save and close</k-btn>
    </template>
  </k-editor-form>
</template>

<script>
//import * as FormItems from '@/components/form_items'
import ContentModel from '@/models/content.js'
import { v4 as uuidv4 } from 'uuid';
import Vue from 'vue'
import Papa from 'papaparse';
import Editor from './Editor';

export default {
  props: ['id', 'data_id'],

  data () {
    return {
      channel: undefined,
      list_data: {},
      import_data: "",
      converted: undefined
    }
  },
  components: {
    Editor
  },
  computed: {
    contents () {
      return Object.values(this.list_data);
    },

    content_list () {
      return _.find(this.content_lists, (cl) => {
        return cl.id == this.id;
      });
    },
    fields () {
      var lt = this.list_type;
      return lt.fields["fields"];
    },
    list_type () {
      var cl = this.content_list;
      return _.find(this.list_types, (lt) => {
        return lt.id == cl.cms_list_type_id;
      });
    },
    content_lists () {
      return Object.values(this.$store.state.cms_lists);
    },
    list_types () {
      return Object.values(this.$store.state.cms_list_types);
    },
  
  },
  mounted() {
    this.connect_ws();
  },
  beforeDestroy: function() {
    this.channel.leave();
  },
  methods: {
    create_data () {
      var data = JSON.parse(this.import_data);
      this.converted = data;
    },

    reset() {

    },
    save (close) {
      this.$refs.editor.save(false);
      this.$root.close_bottom_sheet();
    },
    connect_ws () {
      var self = this;
      this.channel = this.$socket.channel("cms:list_datas:"+this.id);
      this.channel.on("init", function(msg) {
        msg.list_data.forEach(function(d) {
          Vue.set(self.list_data, d.id, d);
        });
      });
      this.channel.on("update", function(msg) {
        Vue.set(self.list_data, msg.list_data.id, msg.list_data);
      });
      this.channel.on("delete", function(msg) {
        Vue.delete(self.list_data, msg.list_data.id);
      });
      this.channel.join();
    }
  }
}
</script>
